import React from 'react';
import { ExternalLink, Rocket } from 'lucide-react';
import './Products.css';

function Products() {
  return (
    <div className="page-content center-content">
      <h1 className="title">
        Products
      </h1>
      <p className="subtitle" style={{ maxWidth: '600px' }}>
        Some of the products we've been proud to work on.
      </p>
       
      <div className="products-grid">
        <a href="https://basedapp.com" target="_blank" rel="noopener noreferrer" className="product-card">
          <div className="product-content">
            <div style={{ background: 'rgba(255, 51, 102, 0.1)', padding: '16px', borderRadius: '50%', marginBottom: '24px' }}>
              <Rocket size={40} color="#ff3366" />
            </div>
            <h2 className="product-title" style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
              Based <ExternalLink size={24} color="#a3a4a9" />
            </h2>
            <p className="product-desc">The future of social finance.</p>
            <div className="product-badge">Coming soon on iOS & Android</div>
          </div>
        </a>
      </div>
    </div>
  );
}

export default Products;